import '../../scss/pages/series.scss';
import { pageHeader } from '../sections/page-header.js';
const seriesPartnerUsTitle=document.querySelector('#series-partner-us-title');
const titleHolderMobile=document.querySelector('.series-partner-us__title-mobile');
const titleHolderDesktop=document.querySelector('.series-partner-us__title-desktop');

//2. Event listeners
document.addEventListener("DOMContentLoaded", function () { 
    pageHeader();
    if (window.innerWidth <= 767) {
        titleHolderMobile.append(seriesPartnerUsTitle)
	} else {
		titleHolderDesktop.append(seriesPartnerUsTitle)
	}
});

window.addEventListener("resize", function(){
    if (window.innerWidth <= 767) {
        titleHolderMobile.append(seriesPartnerUsTitle)
	} else {
		titleHolderDesktop.append(seriesPartnerUsTitle)
	}
});